import script from "./ThePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePrompt.vue?vue&type=script&setup=true&lang=js"

import "./ThePrompt.vue?vue&type=style&index=0&id=7f039197&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f039197"]])

export default __exports__